import { render, staticRenderFns } from "./discountIssuanceStatus.vue?vue&type=template&id=edbd3d20&scoped=true"
import script from "./discountIssuanceStatus.vue?vue&type=script&lang=js"
export * from "./discountIssuanceStatus.vue?vue&type=script&lang=js"
import style0 from "./discountIssuanceStatus.vue?vue&type=style&index=0&id=edbd3d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbd3d20",
  null
  
)

export default component.exports